import React, { Fragment } from 'react';
import spinner from '../assets/spinner.gif';

export default () => (
    <Fragment>
        <img src={spinner} style={{ width: '70px' }} alt="Loading..." />
    </Fragment>
);
